import { Injectable, inject, signal } from '@angular/core';
import { QueryBuilder } from '@softline/core';
import { ClaimReportCustomerRepository } from '../repositories/claim-report-customer.repository';
import {
  ClaimReportCustomerAggregatedRow,
  ClaimReportCustomerQueryRow,
  ClaimReportCustomerSummary,
} from '../types/claim-report-document-query';

@Injectable()
export class ClaimReportCustomerService {
  private readonly repository = inject(ClaimReportCustomerRepository);

  readonly customers = signal<ClaimReportCustomerSummary[]>([]);
  readonly isLoading = signal(false);
  readonly error = signal<unknown>(null);

  async load(): Promise<void> {
    this.isLoading.set(true);
    this.error.set(null);
    try {
      const query = new QueryBuilder<ClaimReportCustomerQueryRow>()
        .column('invoice_customer.number')
        .column('invoice_customer.name')
        .column('sales_order.id', { agg: 'count' })
        .sort('invoice_customer.number', 'DESC')
        //it-konzept: Eine Shop-Bestellung erzeugt einen nicht freigegebenen Auftrag mit dem Kennzeichen „kzvkbranche“ = „V“ (Mietvertrag)
        .filter({ type: 'stringEquals', name: 'sales_order.sale_department', value: 'V' })
        .start(0)
        .end(100)
        .build();
      const result = await this.repository.load({ query });
      const rows = (result?.data ?? []) as unknown as ClaimReportCustomerAggregatedRow[];
      this.customers.set(
        rows.map((row) => ({
          number: row.invoice_customer.number,
          name: row.invoice_customer.name,
          documentCount: row.sales_order['id:count'],
        }))
      );
    } catch (e) {
      this.error.set(e);
      throw e;
    } finally {
      this.isLoading.set(false);
    }
  }
}
